module.exports = __webpack_public_path__ + "static/the-strange-death-of-europe-74f840d3bfd2a2a7bfde8520a8c75954.jpg";